module.exports = __webpack_public_path__ + "public/img/no-access.b74a95f.jpg";